const asset = require('./asset');
const isResolvedResource = require('../contentful/is-resolved-resource');

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

module.exports = {
  make(makeName, image) {
    return {
      make: makeName,
      image: image
    };
  },

  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      make: entry.fields.make['nb-NO'],
      image: null
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.image && entry.fields.image['nb-NO'] && isResolvedResource(entry.fields.image['nb-NO'])) {
      result.image = asset.contentfulToInternal(entry.fields.image['nb-NO']);
    }

    return result;
  },

  internalToContentful(makeImage) {
    const result = {
      sys: {},
      fields: {
        make: {
          'nb-NO': makeImage.make
        },
        image: null
      }
    };

    if (makeImage.id) {
      result.sys = {
        id: makeImage.id
      };
    } else {
      result.sys = {
        contentType: {
          sys: {
            id: makeImage.contentType || 'makeImage'
          }
        }
      };
    }

    // Images:
    if (makeImage.image) {
      result.fields.image = {
        'nb-NO': createAssetLink(makeImage.image)
      };
    }

    return result;
  }
};
